import styles from './ModalConfirmRegister.module.css';
import Modal from 'react-responsive-modal';
import { Button } from '../../../../components/Button';

interface IModalConfirmRegisterPorteiro {
  modalIsOpen: boolean;
  player: any;
  toggleModal: () => void;
}
export function ModalConfirmRegisterPorteiro({
  modalIsOpen,
  player,
  toggleModal,
}: IModalConfirmRegisterPorteiro) {
  return (
    <Modal open={modalIsOpen} onClose={toggleModal} center>
      <div className="contents-modal">
        <div className="d-flex justify-content-center">
          <img
            className={`mb-4 ${styles.alert}`}
            src="https://cdn-icons-png.flaticon.com/512/10490/10490257.png"
            alt=""
          />
        </div>
        {/* {console.log(player)} */}
        <h1 className="title-modal">
          Muito bem vindo, {player && player.name}!
        </h1>
        <p className="subtitle-modal">
          Agora, complete seu cadastro para acessar seu prêmio assim que
          finalizar!
        </p>
      </div>
      <div className={styles.contentBtn}>
        <Button
          isModal
          text="Completar cadastro"
          type="button"
          color="primary"
          onClick={toggleModal}
        />
      </div>
    </Modal>
  );
}
